import "./isLoading.css";

export default function IsLoading() {
  return (
    <section className="sectionLoading">
      <div className="loading-spinner g g2">
        {/* <div style={{ backgroundColor: "red" }}>&nbsp;</div>
        <div style={{ backgroundColor: "green" }}>&nbsp;</div> */}
      </div>
    </section>
  );
}
